// extracted by mini-css-extract-plugin
module.exports = {"pending":"tile-amenities_pending__8lx2F","pendingOverflow":"tile-amenities_pendingOverflow__wDu7S"};